import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Pipe, PipeTransform, } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, Subject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { BaseQueovalItem, Person, QResult, QueovalDate, QueovalDateRange, Select } from '../../models';
import { CoreService, HttpService, QueovalDateService } from '../../services';
import { ToastService } from '../../toast';
import { FilterOption, FilterProperty, FilterPropertyType, FilterBadgeModel, Operator, FilterModelModel, FilterSection } from '../filter.model';

@Component({
  selector: 'q-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
})

export class FilterComponent implements OnInit, OnDestroy {
  constructor(
    protected modalService: NgbModal,
    protected http: HttpService,
    protected indParam: CoreService,
    protected qDate: QueovalDateService,
    protected toast: ToastService,
    protected cd: ChangeDetectorRef,
  ) { }

  @Output('SendEvent') SendEvent: EventEmitter<BaseQueovalItem> = new EventEmitter<BaseQueovalItem>();


  private filterOption$: Subject<FilterOption> = new Subject<FilterOption>();
  //decription du squelette du filtre
  @Input('option') set _filterOption(value: FilterOption) {
    this.filterOption$.next(value);
  };

  private filterModelGroupe$: Subject<Array<FilterModelModel>> = new Subject<Array<FilterModelModel>>();
  //code du group de model
  @Input('modelGroupe') set _filterModelGroupe(value: string) {
    if (this.filterModelList) {
      this.filterModelGroupe$.next(this.filterModelList)
    } else {
      if (!value) {
        this.filterModelGroupe$.next(new Array<FilterModelModel>());
      }

      const model = new FilterModelModel();
      model.GroupMOD = value;
      this.filterModelGroupe = value;
      this.http.postHttp<QResult<Array<FilterModelModel>>>(`${this.indParam.AppParams.apiUrl}api/Filter/FilterModel/GET_FILTER_MODEL_LIST`, model).subscribe(
        (data: QResult<Array<FilterModelModel>>) => {
          this.filterModelList = data.Value;
          if (this.model) {
            let id = this.filterModelList.findIndex(e => e.Code_MOD == this.model);
            if (id >= 0) {
              this.changeFilterModel(id);
            }
          }
          this.filterModelGroupe$.next(this.filterModelList);
        });
    }
  }

  //in/output pour manipuler la liste des badges 
  @Output('badgeChange') FilterBadgeChange: EventEmitter<Array<FilterBadgeModel>> = new EventEmitter<Array<FilterBadgeModel>>();
  @Input('badge')
  set _filterBadge(value: Array<FilterBadgeModel>) {
    if (value) {
      this.ListHiddenFilter = value.filter((filter) => { return filter.Hidden });
      this.currentFilterModel.Filter = value.filter((filter) => { return !filter.Hidden });
    }
  }

  //preselectionner un model de filter depuis l'exterieur
  @Input('model') model: string;

  ngOnInit() {
    //s'execute que si les 2 emmettent un changement
    combineLatest([this.filterOption$, this.filterModelGroupe$]).pipe(take(1)).subscribe(([filterOption, filterModelGroupe]) => {
      this.onInputsLoaded(filterOption);
    })
  }

  ngOnDestroy() {
    this.filterModelGroupe$.unsubscribe();
    this.filterOption$.unsubscribe();
  }

  onInputsLoaded(filterOption: any) {
    if (this.filterOptionLoaded) return;
    this.fixSelect(filterOption);
    this.filterOption = filterOption;
    this.filterOptionLoaded = true;
    this.refreshFilter();

    this.cd.detach();
    setTimeout(() => {
      this.filterOption.Section.forEach((section: FilterSection) => {
        section.FilterProperty.forEach((property: FilterProperty) => {
          property.PropWidth = property.PropWidth > 0 ? property.PropWidth : 'unset';
          if (property.PropType == FilterPropertyType.Select && typeof (property.PropTypeOption) == "string") {
            const route = property.PropTypeOption;
            property.PropTypeOption = this.http.getHttp<QResult<Array<Select>>>(`${this.indParam.AppParams.apiUrl}${route}`).pipe(
              map(data => { property.Loaded = true; return data.Value; })
            );
          }
        });
      });
      this.cd.reattach();
    }, 100);
  }

  //permet de definir si les infos des selects viennent d'un call api async ou que les données sont deja dans l'objet en parametre 
  fixSelect(filterOption: FilterOption) {
    filterOption.Section.flatMap(section => section.FilterProperty.filter(option => option.PropType == FilterPropertyType.Select))
      .forEach((e: any) => e.directData = typeof e.PropTypeOption == 'object');
  }

  filterModelGroupe: string;

  filterModelList: Array<FilterModelModel>;
  currentFilterModel: FilterModelModel = new FilterModelModel();
  currentFilterModelConfig: FilterModelModel = new FilterModelModel();

  SelectedFilterModel: FilterModelModel;
  PlaceHolderSelectFilterModel: FilterModelModel;
  stringvide: string = ""

  public ListHiddenFilter: Array<FilterBadgeModel> = new Array<FilterBadgeModel>();

  public filterOptionLoaded: boolean;

  public DateFrom: string = '';
  public DateTo: string = '';
  public Operator = Operator;

  FilterPropertyType = FilterPropertyType;
  filterOption: FilterOption;

  public refreshFilter() {
    this.currentFilterModel.Filter.sort((a: FilterBadgeModel, b: FilterBadgeModel) => {
      if (!a.Order || !b.Order) {
        return 0;
      } else {
        return a.Order - b.Order;
      }
    });
    this.FilterBadgeChange.emit([...this.currentFilterModel.Filter, ...this.ListHiddenFilter]);
  }

  private DeleteFilter(key: string, listFilterOrigin: Array<FilterBadgeModel>) {
    if (listFilterOrigin && listFilterOrigin.length > 0) {
      for (let i = listFilterOrigin.length - 1; i >= 0; i--) {
        if (listFilterOrigin[i].PropKey == key) {
          listFilterOrigin.splice(i, 1);
        }
      }
    }
  }

  //#region filter change
  public ChangeSelect(event: any, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    this.DeleteFilter(filter.PropKey, listFilterOrigin);
    if (event.target.value) {
      this.AddFilter(filter, event.target.value, listFilterOrigin, event.target.options[event.target.options.selectedIndex].text);
    }
    // this.FixDataBinding(filter);
  }

  public ChangeAvatarSearch(event: Array<any>, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    this.DeleteFilter(filter.PropKey, listFilterOrigin);
    event.forEach((person) => {
      this.AddFilter(filter, person.Id, listFilterOrigin, person.Value);
    });
  }

  public ChangeInput(event: any, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    if (event.target.value) {
      let filterInput = listFilterOrigin.find((f: FilterBadgeModel) => { return f.PropKey == filter.PropKey });
      if (filterInput != undefined) {
        filterInput.PropValue = event.target.value;
        filterInput.Value = `${filter.ShowOperator ? `${this.GetOperator(filterInput.PropOperator)} ` : ''}${event.target.value}`;
      } else {
        this.AddFilter(filter, `${event.target.value}`, listFilterOrigin, `${filter.ShowOperator ? `${this.GetOperator(Operator.Egale)} ` : ''}${event.target.value}`)
      }
    } else {
      this.DeleteFilter(filter.PropKey, listFilterOrigin);
    }
    this.FixDataBinding(filter);
  }

  public ChangeDateRange(dateRange: QueovalDateRange, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    this.DeleteFilter(filter.PropKey, listFilterOrigin);

    if (!this.qDate.IsNull(dateRange.from)) {
      filter.PropOperator = Operator.SuperieurEgale;
      this.AddFilter(filter, this.qDate.ToString(dateRange.from, 'yyyy-MM-dd'), listFilterOrigin, `${this.GetOperator(Operator.SuperieurEgale)} ${this.qDate.ToString(dateRange.from)}`);
    }

    if (!this.qDate.IsNull(dateRange.to)) {
      filter.PropOperator = Operator.InferieurEgale;
      this.AddFilter(filter, this.qDate.ToString(dateRange.to, 'yyyy-MM-dd'), listFilterOrigin, `${this.GetOperator(Operator.InferieurEgale)} ${this.qDate.ToString(dateRange.to)}`);
    }
  }

  ChangeNumberRange(numberRange: Array<number>, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    this.DeleteFilter(filter.PropKey, listFilterOrigin);

   
    if (numberRange[0] >= 0) {
      filter.PropOperator = Operator.SuperieurEgale;
      this.AddFilter(filter, numberRange[0].toString(), listFilterOrigin, `${this.GetOperator(Operator.SuperieurEgale)} ${numberRange[0]}`);
    }
    if (numberRange[1] >= 0) {
      filter.PropOperator = Operator.InferieurEgale;
      this.AddFilter(filter, numberRange[1].toString(), listFilterOrigin, `${this.GetOperator(Operator.InferieurEgale)} ${numberRange[1]}`);
    }
  }


  public ChangeCheck(event: any, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>, isRadio: false) {
    if (isRadio) {
      this.filterOption.Section.flatMap(x => x.FilterProperty).filter(x => x.PropTypeOption == filter.PropTypeOption).map(x => x.PropKey).forEach(x => {
        this.DeleteFilter(x, listFilterOrigin);
      });
    } else {
      this.DeleteFilter(filter.PropKey, listFilterOrigin);
    }

    if (event.currentTarget.checked) {
      this.AddFilter(filter, `${event.currentTarget.checked ? 1 : 0}`, listFilterOrigin, 'Oui');
    }
    this.FixDataBinding(filter);
  }

  public radioCheck(filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    if (listFilterOrigin.some(x => x.PropKey == filter.PropKey)) {
      this.DeleteFilter(filter.PropKey, listFilterOrigin);
      this.FixDataBinding(filter);
    }
  }

  public ChangeTag(event: Array<Select>, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    this.DeleteFilter(filter.PropKey, listFilterOrigin);
    event.forEach(tag => this.AddFilter(filter, tag.id, listFilterOrigin, tag.id));
  }


  public ChangePoduitAction(event: any, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    this.DeleteFilter(filter.PropKey, listFilterOrigin);
    if (event.id) {
      this.AddFilter(filter, `${event.type}|${event.id}`, listFilterOrigin, event.value);
    }
  }

  public FixDataBinding(filter: FilterProperty) {
    let idSection = this.filterOption.Section.findIndex(s => s.FilterProperty.some(p => p.PropKey == filter.PropKey));
    let idProp = this.filterOption.Section[idSection].FilterProperty.findIndex(p => p.PropKey == filter.PropKey);
    this.filterOption.Section[idSection].FilterProperty[idProp] = JSON.parse(JSON.stringify(this.filterOption.Section[idSection].FilterProperty[idProp]));
  }

  public BtnClick(filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    let filterSelected = listFilterOrigin.find((f: FilterBadgeModel) => { return f.PropKey == filter.ConditionToShow });
    let text = filterSelected ? filterSelected!.PropValue : '';
    this.SendEvent.emit({ Value: filter.PropKey, Text: text });

  }

  public ChangeOperator(event: any, filter: FilterProperty, listFilterOrigin: Array<FilterBadgeModel>) {
    let filterInput = listFilterOrigin.find((f: FilterBadgeModel) => { return f.PropKey == filter.PropKey });

    if (filterInput != undefined) {
      filterInput.PropOperator = parseInt(event.target.value);
      filterInput.Value = `${this.GetOperator(parseInt(event.target.value))} ${filterInput.PropValue}`;
    }
  }

  public testCondition(strCondition: string, listFilterOrigin: Array<FilterBadgeModel>): boolean {
    if (!strCondition) {
      return true;
    }
    else {
      return listFilterOrigin.some((f: FilterBadgeModel) => { return f.PropKey == strCondition });
    }

  }

  //#endregion

  public GetComponentInputValue(propName: string, filter: FilterProperty, defaultValue: any) {
    let result = defaultValue;
    if (propName in filter.PropTypeOption) {
      return filter.PropTypeOption[propName];
    }
    return result
  }

  private AddFilter(filter: FilterProperty, PropValue: string, listFilterOrigin: Array<FilterBadgeModel>, BadgeValue?: string) {
    listFilterOrigin.push({ PropType: filter.PropType, PropKey: filter.PropKey, PropValue: PropValue, PropInWhere: filter.PropInWhere ?? true, PropOperator: filter.PropOperator, Order: filter.Order!, Text: filter.Text!, Value: BadgeValue! });
  }

  private GetOperator(op: Operator): string {
    switch (op) {
      case Operator.In: return 'in';
      case Operator.Egale: return '=';
      case Operator.Superieur: return '>';
      case Operator.Inferieur: return '<';
      case Operator.SuperieurEgale: return '>=';
      case Operator.InferieurEgale: return '<=';
      default: return '';
    }
  }


  public changeFilterModel(event: any) {
    if (!event.target) {
      this.currentFilterModel = JSON.parse(JSON.stringify(this.filterModelList[event]));
      return;
    }

    if (event.target.options.selectedIndex > 0) {
      this.currentFilterModel = JSON.parse(JSON.stringify(this.filterModelList[event.target.options.selectedIndex - 1]));
    } else {
      this.currentFilterModel = new FilterModelModel();
    }
  }

  public OpenModelSave(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg', windowClass: 'qmodalover' });
  }

  public RaZFilter() {
    this.currentFilterModel = new FilterModelModel();
    this.refreshFilter();
  }

  public CalcFiltrePosition(filtre: FilterProperty, idSection: number, idFiltre: number) {

    //const filtrePropKey = this.FilterOption.Section[idSection].FilterProperty[idFiltre].PropKey;

    //if (idFiltre > 0 && this.FilterOption.Section[idSection].FilterProperty[idFiltre - 1].PropKey == filtrePropKey) {
    //  return 'justify-content-start pl-2';
    //}

    //if (idFiltre < this.FilterOption.Section[idSection].FilterProperty.length && this.FilterOption.Section[idSection].FilterProperty[idFiltre + 1].PropKey == filtrePropKey) {
    //  return 'justify-content-end pr-2';
    //}
  }


  public selectModelConfig(model: string | null) {
    if (model) {
      let configModel = this.filterModelList.find(e => { return e.Code_MOD == model });
      if (configModel) {
        this.currentFilterModelConfig = JSON.parse(JSON.stringify(configModel));
      }
    } else {
      this.currentFilterModelConfig = new FilterModelModel();
    }
  }

  public saveModelConfig() {
    let model: FilterModelModel = this.currentFilterModelConfig
    model.GroupMOD = this.filterModelGroupe;
    this.http.postHttp<QResult<Array<FilterModelModel>>>(`${this.indParam.AppParams.apiUrl}api/Filter/FilterModel/SAVE_UPDATE_FILTER_MODEL`, model).subscribe((data: QResult<Array<FilterModelModel>>) => {
      let code_mod: string = this.currentFilterModelConfig.Code_MOD
      if (!code_mod) {
        let newModel = data.Value.filter(f1 => !this.filterModelList.some(f2 => f1.Code_MOD == f2.Code_MOD));
        code_mod = newModel[0].Code_MOD
      }
      this.filterModelList = data.Value;
      this.filterModelGroupe$.next(this.filterModelList);
      this.selectModelConfig(code_mod);
    });
  }

  public deleteModelConfig() {
    let model = new FilterModelModel();
    model.GroupMOD = this.filterModelGroupe;
    model.Code_MOD = this.currentFilterModelConfig.Code_MOD;
    this.http.postHttp<QResult<Array<FilterModelModel>>>(`${this.indParam.AppParams.apiUrl}api/Filter/FilterModel/DELETE_FILTER_MODEL`, model).subscribe((data: QResult<Array<FilterModelModel>>) => {
      this.currentFilterModelConfig = new FilterModelModel();
      this.filterModelList = data.Value;
      this.filterModelGroupe$.next(this.filterModelList);

    });
  }

  public addToClipboard() {
   /* const el = document.createElement('textarea');
    el.value = `'MODEL=${this.currentFilterModelConfig.Code_MOD}'`;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);*/


    navigator.clipboard.writeText(`'MODEL=${this.currentFilterModelConfig.Code_MOD}'`);
   
    this.toast.showInfoToast("Code copié dans le presse papier");
  }
}



//#region Pipe affectation valeur
@Pipe({ name: 'SelectValue' })
export class SelectValue implements PipeTransform {
  transform(value: Array<FilterBadgeModel>, PropKey: string): string {
    let result: string = "";
    if (value.length > 0) {
      let filter = value.find((filter: FilterBadgeModel) => { return filter.PropKey == PropKey });
      if (filter != undefined) {
        result = filter.PropValue;
      }
    }
    return result;
  }
}

@Pipe({ name: 'DateRangeValue' })
export class DateRangeValue implements PipeTransform {
  constructor(
    private qDate: QueovalDateService,
  ) { }

  transform(value: Array<FilterBadgeModel>, PropKey: string, isDebut: boolean): QueovalDate {
    let result: QueovalDate = new QueovalDate();
    if (value.length > 0) {
      const operator: Operator = isDebut ? Operator.SuperieurEgale : Operator.InferieurEgale
      let filter = value.find((filter: FilterBadgeModel) => { return filter.PropKey == PropKey && filter.PropOperator == operator });
      if (filter != undefined) {
        result = filter.PropValue ? this.qDate.FromString(filter.PropValue, 'yyyy-MM-dd') : new QueovalDate();
      }
    }
    return result;
  }
}



@Pipe({ name: 'NumberRangeValue' })
export class NumberRangeValue implements PipeTransform {
  transform(value: Array<FilterBadgeModel>, PropKey: string, isLowValue: boolean): number {
    let result: number = 0;
    if (value.length > 0) {
      const operator: Operator = isLowValue ? Operator.SuperieurEgale : Operator.InferieurEgale
      let filter = value.find((filter: FilterBadgeModel) => { return filter.PropKey == PropKey && filter.PropOperator == operator });
      if (filter != undefined) {
        result = typeof (filter.PropValue) == 'number' ? filter.PropValue : Number(filter.PropValue);
      }
    }
    return result;
  }
}



@Pipe({ name: 'InputNumberValue' })
export class InputNumberValue implements PipeTransform {
  transform(value: Array<FilterBadgeModel>, PropKey: string): number {
    let result: any = undefined;
    if (value.length > 0) {
      let filter = value.find((filter: FilterBadgeModel) => { return filter.PropKey == PropKey });
      if (filter != undefined) {
        return parseInt(filter.PropValue);
      }
    }
    return result;
  }
}

@Pipe({ name: 'CheckValue' })
export class CheckValue implements PipeTransform {
  transform(value: Array<FilterBadgeModel>, PropKey: string): boolean {
    let result: boolean = false;
    if (value.length > 0) {
      let filter = value.find((filter: FilterBadgeModel) => { return filter.PropKey == PropKey });
      if (filter != undefined) {
        return filter.PropValue == '1';
      }
    }
    return result;
  }
}

@Pipe({ name: 'AvatarValue' })
export class AvatarValue implements PipeTransform {
  transform(value: Array<FilterBadgeModel>, PropKey: string): Array<string> {
    let result: Array<string> = [];
    if (value.length > 0) {
      let filter = value.filter((filter: FilterBadgeModel) => { return filter.PropKey == PropKey });
      if (filter.length > 0) {
        filter.forEach((person: FilterBadgeModel) => {
          result.push(person.PropValue)
        })
      }
    }
    return result;
  }
}

@Pipe({ name: 'OperatorValue' })
export class OperatorValue implements PipeTransform {
  transform(value: Array<FilterBadgeModel>, PropKey: string): Operator {
    let result: Operator = Operator.Egale;
    if (value.length > 0) {
      let filter = value.find((filter: FilterBadgeModel) => { return filter.PropKey == PropKey });
      if (filter != undefined) {
        result = filter.PropOperator;
      }
    }
    return result;
  }
}

@Pipe({ name: 'ProduitAction' })
export class ProduitActionValue implements PipeTransform {
  transform(value: Array<FilterBadgeModel>, PropKey: string): string {
    let result: string = '';
    if (value.length > 0) {
      let filter = value.filter((filter: FilterBadgeModel) => { return filter.PropKey == PropKey });
      if (filter.length > 0) {
        return filter[0].PropValue;//.split('|')[0];
      }
    }
    return result;
  }
}


@Pipe({ name: 'TagValue' })
export class TagValue implements PipeTransform {
  transform(value: Array<FilterBadgeModel>, PropKey: string): Array<string> {
    let result: Array<string> = new Array<string>();
    if (value.length > 0) {
      let filter = value.filter((filter: FilterBadgeModel) => { return filter.PropKey == PropKey });
      if (filter != undefined) {
        return filter.map(m => m.PropValue);
      }
    }
    return result;
  }
}
//#endregion


